import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isExistSoftVersion
    ? _c(
        "div",
        [
          _c("SoftVersionImage", {
            attrs: { image: _vm.softData.image },
            on: {
              click: function ($event) {
                _vm.isVisibleBottomSheet = true
              },
            },
          }),
          _vm._v(" "),
          _c(
            "CoreBottomSheet",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          VBtn,
                          {
                            staticClass: "branding-btn branding-btn--primary",
                            attrs: {
                              block: "",
                              depressed: "",
                              color: "primary",
                            },
                            on: {
                              click: function ($event) {
                                _vm.isVisibleBottomSheet = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.tStatic("Понятно")) +
                                "\n      "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3923277973
              ),
              model: {
                value: _vm.isVisibleBottomSheet,
                callback: function ($$v) {
                  _vm.isVisibleBottomSheet = $$v
                },
                expression: "isVisibleBottomSheet",
              },
            },
            [
              _c("div", { staticClass: "text-h6 text--text mb-4" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.tStatic("Пользуется порталом с версией")) +
                    " " +
                    _vm._s(_vm.softData.translate) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex flex-column gr-3 text-body-1" },
                _vm._l(_vm.listBenefits, function (benefit, i) {
                  return _c("div", { key: i }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getFirstLetterUpper(_vm.tStatic(benefit))) +
                        "\n      "
                    ),
                  ])
                }),
                0
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }